import { client } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type InsertCustomer, type Customer } from "@shared/schema";
import { handleClientMethod } from "../client";

export const useCreateCustomer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: InsertCustomer) => {
      return await handleClientMethod(
        client.POST("/api/customers", {
          body: data,
        }),
      );
    },
    onSuccess: (newCustomer) => {
      const existingCustomers = queryClient.getQueryData<Customer[]>([
        "customers",
      ]);
      if (existingCustomers) {
        queryClient.setQueryData(
          ["customers"],
          [...existingCustomers, newCustomer],
        );
      }
      queryClient.invalidateQueries({ queryKey: ["customers"] });
    },
  });
};
